function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
    // 生成随机时间
    function generateRandomTime() {
      var hours = Math.floor(Math.random() * 15) + 1
      var minutes = Math.floor(Math.random() * 60)
      var seconds = Math.floor(Math.random() * 60)
      //总共的毫秒数
      var targetTime = (hours * 3600 + minutes * 60 + seconds) * 1000

      return targetTime
    }
    function TimeDown(value) {
      //倒计时的总秒数
      var totalSeconds = parseInt(value / 1000)
      //取模（余数）
      var modulo = totalSeconds % (60 * 60 * 24)
      //小时数
      var hours = Math.floor(modulo / (60 * 60))
      modulo = modulo % (60 * 60)
      //分钟
      var minutes = Math.floor(modulo / 60)
      //秒
      var seconds = modulo % 60

      hours = hours.toString().length == 1 ? '0' + hours : hours
      minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
      seconds = seconds.toString().length == 1 ? '0' + seconds : seconds

      //输出到页面
      $('.sp_hour').html(hours)
      $('.sp_minute').html(minutes)
      $('.sp_second').html(seconds)
      //延迟一秒执行自己
      if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
      } else {
        setTimeout(function () {
          TimeDown(value - 1000)
        }, 1000)
      }
    }
    TimeDown(generateRandomTime())
    // 头部固定
    $('header').addClass('stiky')
    $(document).scroll(function (e) {
      var beforScrollTop = $(document).scrollTop()
      setTimeout(function () {
        $('header').addClass('stiky')
      }, 50)
    })
    // 轮播
    // new Swiper('#swiper2', {
    //   loop: true,
    //   centeredSlides: true,
    //   spaceBetween: 0,
    //   slidesPerView: 1.7,
    //   autoplay: {
    //     delay: 3000,
    //     stopOnLastSlide: false,
    //     disableOnInteraction: false,
    //   },
    //   pagination: {
    //     el: '.swiper-pagination',
    //     clickable: true,
    //   },
    // })
    new Swiper('#swiper', {
      loop: true,
      centeredSlides: true,
      spaceBetween: 15,
      slidesPerView: 2.4,
      freeMode: true,
      speed: 4500, //匀速时间
      autoplay: {
        delay: 0,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
    })
    var swiper2 = new Swiper('.mySwiper3', {
      spaceBetween: 23,
      slidesPerView: 3,
      watchSlidesVisibility: true, //防止不可点击
      direction: 'vertical',
      on: {
        click: function () {
          var index = this.clickedIndex
          $('.top-product>img').attr('src', imgArr[index])
          $('.img-pop>img').attr('src', imgArr2[index])
          $('#color>div')
            .eq(index)
            .addClass('active')
            .siblings()
            .removeClass('active')
        },
      },
    })
    $('.option').click(function () {
      $(this).siblings().removeClass('active')
      $(this).addClass('active')
    })
    // style选项
    function tofixed2(num) {
      return num.toString().slice(0, num.toString().indexOf('.') + 3)
    }
    let prods = window.product
    console.log(prods, 'prods')
    function getCur() {
      let color = $('#color div.active').attr('data-val')
      let size = $('#size div.active').attr('data-val')
      let type = $('#type div.active').attr('data-val')
      return prods.filter(
        item => item.option1 == color && item.option3 == size && item.option2 == type
      )[0]
    }
    function changePrice() {
      let num = $('#calcNumber').val()
   
      let price = ((getCur().price * num) / 100).toFixed(2)
      let compare = ((getCur().compare_at_price * num) / 100).toFixed(2)
      // price = (price + '').replace('.', ',')
      // compare = (compare + '').replace('.', ',')
      $('#new').html(price)
      $('#old').html(compare)
      let off_font =
        100 - Math.ceil((getCur().price / getCur().compare_at_price) * 100)

      $('.product-part .sp-pro-offs-top .num').html(`${off_font}`)
    }
    $('.sp-btn-style').click(function () {
      let num = $('#calcNumber').val()
      window.location.href = '/cart/' + getCur().id + ':' + num
    })
    $('.reduce').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) - 1
      if (num > 0) {
        input.value = num
        changePrice()
      }
    })
    $('.add').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) + 1
      input.value = num
      changePrice()
    })
    // style选项
    let typeOptions = $('.option')

    // 切换选项
    var imgArr = [
        'https://cdn.shopify.com/s/files/1/0618/4150/6441/files/2026032301-pro.png',
        'https://cdn.shopify.com/s/files/1/0618/4150/6441/files/20260331-pro1.png',
        'https://cdn.shopify.com/s/files/1/0618/4150/6441/files/2026032303-pro.png?v=1774248157',
        'https://cdn.shopify.com/s/files/1/0618/4150/6441/files/20260331-pro2.png',
        'https://cdn.shopify.com/s/files/1/0618/4150/6441/files/2026032305-pro.png?v=1774248157',
        'https://cdn.shopify.com/s/files/1/0618/4150/6441/files/20260331-pro3.png',
        'https://cdn.shopify.com/s/files/1/0618/4150/6441/files/2026032302-pro.png',
        'https://cdn.shopify.com/s/files/1/0618/4150/6441/files/20260331-pro4.png',
        'https://cdn.shopify.com/s/files/1/0618/4150/6441/files/2026032304-pro.png',
        'https://cdn.shopify.com/s/files/1/0618/4150/6441/files/20260331-pro5.png',
        'https://cdn.shopify.com/s/files/1/0618/4150/6441/files/2026032306-pro.png',
        'https://cdn.shopify.com/s/files/1/0618/4150/6441/files/20260331-pro6.png',
        'https://cdn.shopify.com/s/files/1/0618/4150/6441/files/2026033001-pro.png',
        'https://cdn.shopify.com/s/files/1/0618/4150/6441/files/2026033002-pro.png',
        'https://cdn.shopify.com/s/files/1/0618/4150/6441/files/2026033003-pro.png',
        'https://cdn.shopify.com/s/files/1/0618/4150/6441/files/2026033004-pro.png',
        'https://cdn.shopify.com/s/files/1/0618/4150/6441/files/2026033005-pro.png',
        'https://cdn.shopify.com/s/files/1/0618/4150/6441/files/2026033006-pro.png',
    //   'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/2025-1-18-pro1.png',
    //   'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/2025-1-18-pro2.png',
    //   'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/2025-1-18-pro3.png',
    //   "https://cdn.shopify.com/s/files/1/0675/5234/6360/files/2_859c11fd-9cb2-4707-9841-4e60947ee52c.png?v=1758158141",
    //   "https://cdn.shopify.com/s/files/1/0675/5234/6360/files/5_acff4571-52de-4131-9c64-9ad09eda52d1.png?v=1758158141",
    //   "https://cdn.shopify.com/s/files/1/0675/5234/6360/files/10_6829c286-f433-4dec-934b-3255218e6b66.png?v=1758158141"
    ]
    typeOptions.click(function () {
      $(this).addClass('active').siblings().removeClass('active')
      changePrice()
    })
    $('.sp-pd6 .option').click(function () {
      $(this).addClass('active').siblings().removeClass('active')
      var index = $("#size .active").index()
      const color = $("#color .active").index()
      const type = $("#type .active").index()
      // let _index = color>=2?3:0
      var position = 0
      $('.top-product>img').attr('src', imgArr[color + index * 2 + type * 6])
      if(color>0){
        $('.sp-pro-offs').hide()
        $('.top-product > img').css('height','100%')
      }else{
        $('.sp-pro-offs').show()
        $('.top-product > img').css('height','90%')

      }
    //   if(_index===3){
    //     $('.top-product>img').css({
    //       width:"880px"
    //     })
    //     position = 89
    //   }else{
    //     $('.top-product>img').css({
    //       width:"auto"
    //     })
    //   }
    //   changePrice()
      if (index == 1) {

        let price_font = (getCur().price / 5 / 100).toFixed(2)
        $('.product-part .price-group2 span').html(`${price_font}`)
        $('.sp-pro-offs').css({
          right: 180,
          top: 529-position,
        })
        $('.sp-pro-offs-top').css({
          left: 93,
        })
      } else if (index == 2) {
        let price_font = (getCur().price / 10 / 100).toFixed(2)
        $('.product-part .price-group2 span').html(`${price_font}`)
        $('.sp-pro-offs').css({
          right: 108,
          top: 504-position+10,
        })
        $('.sp-pro-offs-top').css({
          left: 777,
        })
      } else {
        let price_font = (getCur().price / 2 / 100).toFixed(2)
        $('.product-part .price-group2 span').html(`${price_font}`)
        $('.sp-pro-offs').css({
          right: 148,
          top: 439,
        })
        $('.sp-pro-offs-top').css({
          left: 93,
        })
      }

    })
    // style选项
    $('.cart-btn').click(function () {
      $(this).children('img').addClass('on')
      setTimeout(function () {
        $('.cart-btn').children('img').removeClass('on')
      }, 500)
      $('.sp-header-top .sp-cart').addClass('on')
      setTimeout(function () {
        $('.sp-header-top .sp-cart').removeClass('on')
      }, 500)
    })
    addCart()
    function addCart() {
      // 加入购物车
      $('.addCerts').click(function () {
        var data = {
          id: getCur().id,
          quantity: $('#calcNumber').val(),
        }
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          success: function () {
            $.getJSON(
              window.Shopify.routes.root + 'cart.js',
              function (result) {
                $('#cardNum').html(result.item_count)
              }
            )
          },
          dataType: 'json',
        })
        var img = $('.top-product img')
        var flyer = img[0].cloneNode(true)
        flyer.classList.add('clone')
        $('.product-part').append(flyer)
        $('.clone').css({
          width: img.width(),
          height: img.height(),
          position: 'fixed',
          top: img[0].offsetTop,
          left: img.offset().left,
          'z-index': '99',
        })
        var offset = $('.sp-cart')[0].getBoundingClientRect()
        $('.sp-cart').addClass('shake')
        setTimeout(() => {
          $('.sp-cart').removeClass('shake')
        }, 1000)
        let finish = $('.sp-cart')
        $('.clone').animate(
          {
            top: finish[0].offsetTop,
            left: finish[0].offsetLeft + finish.width() / 2,
            width: 50, // 结束时的大小，根据需要调整
            height: 50, // 结束时的大小，根据需要调整
            opacity: 0.4,
          },
          1000,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach() // 完成动画后移除克隆的图片
              }
            )
          }
        )
      })
    }
  })
  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach(subArray => {
        subArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach(url => {
        const img = new Image()
        img.src = url
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    // preloadImages(imagesOneDim)
    // preloadImages(imagesTwoDim)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop - $('header').height()
        window.scroll({
          top: offsetTop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }
}

mainRender()
